import React from 'react';

import "./Sheet.scss";

export const Sheet = (props) => {
    const { list } = props;

    return (
        <dl className="Sheet">
            {list.map((item, index) => (
                <div key={index} className="menu-item">
                    <dt>{item.title}</dt>
                    <dd>{item.price}</dd>
                </div>
            ))}
        </dl>
    )
}

